import React from 'react';

import { Button } from '@xingternal/button';
import { IconMore } from '@xingternal/icons';
import { trackClickHeaderMoreAction } from '@xingternal/pages-tracking'; // eslint-disable-line
import { usePopOver } from '@xingternal/pop-over';
import { ShareTabOmView } from '@xingternal/share';

import MenuContainer from './MenuContainer';
import type { HeaderProps } from '../../types';

import styles from './HeaderMoreActions.css';

type HeaderMoreActionsProps = Pick<
  HeaderProps,
  'globalId' | 'pageUrl' | 'ctaType'
> & {
  isEditor: boolean;
  smallOnWide?: boolean;
};

const HeaderMoreActions = ({
  isEditor,
  globalId,
  pageUrl,
  smallOnWide,
  ctaType,
}: HeaderMoreActionsProps) => {
  const popOver = usePopOver();

  const moreButtonClick = (isEditor: boolean) => {
    popOver.handleShow();
    trackClickHeaderMoreAction({ isEditor });
  };

  return (
    <div className={styles.moreWrapper}>
      <Button
        variant={'tertiary'}
        data-testid={'MODAL_TOGGLE'}
        className={styles.button}
        onClick={() => moreButtonClick(isEditor)}
        innerRef={popOver.triggerRef}
        size={'medium'}
        sizeWide={smallOnWide ? 'small' : undefined}
        aria-label="More"
      >
        <IconMore width={16} height={16} />
      </Button>
      <ShareTabOmView
        url={pageUrl}
        propChannel="wbm/EntityPages"
        entryPoint="entity_page_social_share"
        interactionTargetUrn={globalId}
        trigger={(trigger: any) => (
          <MenuContainer
            sharePage={trigger}
            popOver={popOver}
            ctaType={ctaType}
          />
        )}
      />
    </div>
  );
};

export default HeaderMoreActions;
